import { useEffect, useState } from 'react';
import { adminApi } from '../../adminApi';
import { IconShield } from '../../components/Icon';
import { AdminHeader, Reveal } from './ui';

export default function AdminSecurity() {
  const [rows, setRows] = useState<any[]>([]);
  useEffect(()=>{ adminApi.securityEvents().then(r=>{ if(r.status===200) setRows(r.data?.events||[]); }); },[]);
  return (
    <div>
      <AdminHeader icon={IconShield} title="Security events" subtitle="Root/emulator flags, country jumps, and admin actions." />
      <Reveal className="glass overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-xs uppercase tracking-widest text-[color:var(--color-ink-faint)] border-b border-[color:var(--color-line)]"><tr><th className="text-left px-6 py-4">User</th><th className="text-left px-6">Type</th><th className="text-left px-6">Details</th><th className="text-left px-6">Date</th></tr></thead>
            <tbody>
              {rows.map((e:any,i:number)=><tr key={i} className="border-b border-white/5"><td className="px-6 py-4 font-mono text-xs">{e.username}</td><td className="px-6"><span className="chip">{e.event_type}</span></td><td className="px-6 max-w-md truncate text-xs text-[color:var(--color-ink-dim)]">{e.details}</td><td className="px-6 text-xs text-[color:var(--color-ink-faint)]">{String(e.created_at).slice(0,16)}</td></tr>)}
              {rows.length===0 && <tr><td colSpan={4} className="px-6 py-12 text-center text-sm text-[color:var(--color-ink-faint)]">No events</td></tr>}
            </tbody>
          </table>
        </div>
      </Reveal>
    </div>
  );
}
